export enum eSiteType {
    cdr = 'CDR'
}